module.exports = __webpack_public_path__ + "img/mb_hm_block01_tc.19350020.jpg";